import * as EmailValidator from "email-validator";
import * as CardValidator from "card-validator";

const MAX_CVV_CODE_LENGTH = 4;

export default class Validator {
  public static validateEmail(email: string) {
    return EmailValidator.validate(email);
  }

  public static isPhoneNumber(phoneNumber: string) {
    const regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return regex.test(phoneNumber);
  }

  public static validateDomain(domain: string) {
    return EmailValidator.validate(`test@${domain}`);
  }

  public static emailDomain(email: string) {
    return email.split("@")[1];
  }

  public static isName(name: string) {
    const regex = /^[a-zA-Z ]+$/;
    return regex.test(name);
  }

  public static isCurrency(currency: string) {
    const regex = /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;
    return regex.test(currency);
  }

  public static filterCardNumber(card?: string) {
    if (!card) {
      return "";
    } else {
      return card.replace(/\s+/g, "");
    }
  }

  public static isValidCardNumber(card: string): boolean {
    const result = CardValidator.number(card);
    return result.isPotentiallyValid;
  }

  public static isValidCardCode(code: string): boolean {
    const result = CardValidator.cvv(code, MAX_CVV_CODE_LENGTH);
    return result.isPotentiallyValid;
  }

  public static isValidUrl(url: string) {
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return pattern.test(url);
  }
}



// WEBPACK FOOTER //
// ./src/services/Validators/Validator.ts